<app-header></app-header>

<div class="contact-page">
  <!-- Titre principal -->
  <section class="main-title-section py-4">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-10 text-center">
          <h1 class="main-title my-4">Le Service Clients de pdf-to-word.fr est là pour Vous Aider !</h1>
        </div>
      </div>
    </div>
  </section>

  <!-- Section Contact -->
  <section class="contact-section pb-5">
    <div class="container">
      <div class="row justify-content-center">
          <div class="row">
            <!-- Formulaire de contact -->
            <div class="col-lg-7 mb-4">
              <div class="contact-form-card">
                <h1 class="contact-title mb-2">Contactez-nous</h1>
                <p class="contact-subtitle mb-4">Réponse sous 24h ouvrées</p>
                
                <!-- Message de succès -->
                <div *ngIf="submitSuccess" class="alert alert-success alert-dismissible fade show" role="alert">
                  <strong>Message envoyé avec succès !</strong> Nous vous répondrons dans les plus brefs délais.
                  <button type="button" class="btn-close" (click)="submitSuccess = false" aria-label="Close"></button>
                </div>
                
                <!-- Message d'erreur -->
                <div *ngIf="submitError" class="alert alert-danger alert-dismissible fade show" role="alert">
                  <strong>Erreur :</strong> {{ submitError }}
                  <button type="button" class="btn-close" (click)="submitError = ''" aria-label="Close"></button>
                </div>
                
                <!-- Détails des erreurs de validation -->
                <div *ngIf="errorDetails.length > 0" class="alert alert-warning" role="alert">
                  <strong>Erreurs de validation :</strong>
                  <ul class="mb-0 mt-2">
                    <li *ngFor="let error of errorDetails">{{ error.field }}: {{ error.message }}</li>
                  </ul>
                </div>
                
                <form class="contact-form" [formGroup]="contactForm" (ngSubmit)="onSubmit()">
                  <div class="mb-3">
                    <label for="name" class="form-label">Votre nom *</label>
                    <input 
                      type="text" 
                      class="form-control" 
                      id="name" 
                      formControlName="name"
                      [class.is-invalid]="hasFieldError('name')"
                      required>
                    <div *ngIf="hasFieldError('name')" class="invalid-feedback d-block">
                      {{ getFieldError('name') }}
                    </div>
                  </div>
                  
                  <div class="mb-3">
                    <label for="email" class="form-label">Votre adresse email *</label>
                    <input 
                      type="email" 
                      class="form-control" 
                      id="email" 
                      formControlName="email"
                      [class.is-invalid]="hasFieldError('email')"
                      required>
                    <div *ngIf="hasFieldError('email')" class="invalid-feedback d-block">
                      {{ getFieldError('email') }}
                    </div>
                  </div>
                  
                  <div class="mb-3">
                    <label for="subject" class="form-label">L'objet de votre demande *</label>
                    <input 
                      type="text" 
                      class="form-control" 
                      id="subject" 
                      formControlName="subject"
                      [class.is-invalid]="hasFieldError('subject')"
                      required>
                    <div *ngIf="hasFieldError('subject')" class="invalid-feedback d-block">
                      {{ getFieldError('subject') }}
                    </div>
                  </div>
                  
                  <div class="mb-4">
                    <label for="message" class="form-label">Votre message *</label>
                    <textarea 
                      class="form-control" 
                      id="message" 
                      rows="5" 
                      formControlName="message"
                      [class.is-invalid]="hasFieldError('message')"
                      required></textarea>
                    <div *ngIf="hasFieldError('message')" class="invalid-feedback d-block">
                      {{ getFieldError('message') }}
                    </div>
                  </div>
                  
                  <div class="text-center">
                    <button 
                      type="submit" 
                      class="btn btn-primary contact-submit-btn"
                      [disabled]="isSubmitting || contactForm.invalid">
                      <span *ngIf="!isSubmitting">Envoyer</span>
                      <span *ngIf="isSubmitting">
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Envoi en cours...
                      </span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
            
            <!-- Informations de contact -->
            <div class="col-lg-5">
              <!-- Section Téléphone -->
              <div class="contact-info-card mb-4">
                <h3 class="info-title">PAR TÉLÉPHONE</h3>
                <p class="info-text mb-3">Du lundi au vendredi de 9h00 à 12h00 et de 13h00 à 18h00</p>
                
                <div class="phone-section">
                  <div class="phone-number-box">
                    <span class="phone-number">0 532 183 976</span>
                  </div>
                  <div class="service-info-box">
                    <div class="service-text">Service gratuit</div>
                    <div class="service-text">+ prix appel</div>
                  </div>
                </div>
              </div>
              
              <!-- Section Médiation -->
              <div class="contact-info-card">
                <h3 class="info-title">Médiation de la consommation</h3>
                <p class="info-text">
                  Conformément aux articles L 611-1 et suivants du code de la consommation, 
                  tout différend ou litige dit de consommation, peut faire l'objet d'un 
                  règlement amiable par médiation auprès d'un médiateur de la consommation. 
                  Le médiateur choisi par le professionnel est CM2C. Le consommateur peut 
                  saisir le médiateur à cette adresse:
                </p>
                <a href="https://www.cm2c.net" class="mediation-link" target="_blank">www.cm2c.net</a>
              </div>
            </div>
          </div>
      </div>
    </div>
  </section>
</div>

<app-footer></app-footer>
